  export default function integerise(value) {
    if (!value) {
      // TODO: refactor to remove ESLint disable
      // eslint-disable-next-line no-param-reassign
      value = 0;
    }
    return parseInt((value ? value : 0).toString().replace(/[^0-9]/g, ""), 10);
  }
